module.exports = __webpack_public_path__ + "static/media/sub_menu_eyewear.5d718216.png";